import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { Box, Divider, IconButton, Tooltip, styled } from "@mui/material";
import { IWithClassName, IWithThemeProps } from "../../theme/default.theme";

interface IProps extends IWithClassName {
    onSelectAll: () => void;
    onUnselectAll: () => void;
    onSelect: () => void;
    onUnselect: () => void;
    addTitle?: string;
    removeTitle?: string;
    addAllTitle?: string;
    removeAllTitle?: string;
    disabled?: boolean;
}
const ControllerBox = ({
    className,
    onSelectAll,
    onUnselectAll,
    onSelect,
    onUnselect,
    addTitle,
    removeTitle,
    addAllTitle,
    removeAllTitle,
    disabled,
}: IProps) => (
    <Box className={className}>
        <IconButton
            onClick={disabled ? undefined : onSelect}
            disabled={disabled}
        >
            <Tooltip title={addTitle ?? ""}>
                <ArrowBack />
            </Tooltip>
        </IconButton>
        <IconButton
            onClick={disabled ? undefined : onUnselect}
            disabled={disabled}
        >
            <Tooltip title={removeTitle ?? ""}>
                <ArrowForward />
            </Tooltip>
        </IconButton>
        <IconButton
            onClick={disabled ? undefined : onSelectAll}
            disabled={disabled}
        >
            <Tooltip title={addAllTitle ?? ""}>
                <ArrowBack />
            </Tooltip>
            <Divider />
        </IconButton>
        <IconButton
            onClick={disabled ? undefined : onUnselectAll}
            disabled={disabled}
        >
            <Tooltip title={removeAllTitle ?? ""}>
                <ArrowForward />
            </Tooltip>
            <Divider />
        </IconButton>
    </Box>
);

export default styled(ControllerBox)(({ theme }: IWithThemeProps) => ({
    width: 50,
    display: "flex",
    flexDirection: "column",
    gap: theme?.spacing(1.25),
    justifyContent: "center",
    ".MuiIconButton-root": {
        backgroundColor: theme?.palette.collapsibleFeatures.bgColor,
        borderRadius: theme?.spacing(1.25),
        display: "flex",
        flexDirection: "column",
        "&:disabled": {
            opacity: 0.3,
        },
    },
    ".MuiIconButton-root: hover": {
        backgroundColor: theme?.palette.collapsibleFeatures.bgColor,
    },
    ".MuiSvgIcon-root": {
        color: theme?.palette.text.primary,
    },
    ".MuiDivider-root": {
        backgroundColor: theme?.palette.text.primary,
        width: 17,
        height: 1,
    },
}));
